import { MRT_ColumnDef, MRT_TableOptions } from 'material-react-table'
import { Member } from '@stytch/vanilla-js'
import ZerapixTable from '@/components/zerapix-table/ZerapixTable'
import useZerapixTable from '../zerapix-table/useZerapixTable'

type UsersTableProps = {
  users: Member[]
  columns?: MRT_ColumnDef<Member>[]
  isLoading?: boolean
  renderTableActions?: MRT_TableOptions<Member>['renderTopToolbarCustomActions']
} & Omit<MRT_TableOptions<Member>, 'data' | 'columns'>

const defaultColumns: MRT_ColumnDef<Member>[] = [
  {
    header: 'Name',
    accessorKey: 'name',
  },
  {
    header: 'Email',
    accessorKey: 'email_address',
  },
]

export default function BaseUsersTable({
  users,
  columns = defaultColumns,
  enableRowSelection = false,
  enableMultiRowSelection = false,
  isLoading = false,
  renderTableActions,
  renderRowActionMenuItems,
  ...props
}: UsersTableProps) {
  const table = useZerapixTable<Member>({
    title: 'Users',
    columns,
    data: users,
    renderTableActions,
    renderRowActionMenuItems,
    enableColumnResizing: true,
    enableMultiRowSelection,
    enableRowSelection,
    enableRowActions: !!renderRowActionMenuItems,
    enableSorting: true,
    getRowId: (row) => row.member_id,
    state: {
      showSkeletons: isLoading,
    },
    localization: {
      noRecordsToDisplay: 'No users have been added to this team.',
    },
    ...props,
  })

  return <ZerapixTable<Member> table={table} />
}
